<template>
  <FriedModal
    class="authorizenet-container"
    :loading="loading"
    :size="ModalSize.Large"
    @close="handleClose"
  >
    <template #container>
      <FriedModalSubContainer>
        <template #header>
          <FriedModalHeader :header="title" />
        </template>
        <div v-if="shouldRender" class="authorizenet-container">
          <iframe class="authorizenet-iframe" frameborder="no" :src="externalUrl"></iframe>
        </div>
        <template #footer>
          <FriedModalButtonsFooter>
            <FriedButton
              data-external="authorize-net-button"
              :button-type="ButtonType.Secondary"
              :mobile="true"
              @click="handleClose"
            >
              {{ $t('payment-is-done') }}
            </FriedButton>
          </FriedModalButtonsFooter>
        </template>
      </FriedModalSubContainer>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import { ButtonType, ModalSize } from '@getaccept/fried-tofu';
import type { Integration } from '@getaccept/lib-shared-new/src/integrations/types/integration';
import type { PropType } from 'vue';
import { computed, ref, defineComponent } from 'vue';
import type { SigningPageRecipient } from '@getaccept/lib-shared-new/src/types/signing-page-recipient';
import type { SigningPageDocument } from '@getaccept/lib-shared-new/src/types/signing-page-document';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    recipient: { type: Object as PropType<SigningPageRecipient>, required: true },
    document: { type: Object as PropType<SigningPageDocument>, required: true },
    integration: { type: Object as PropType<Integration>, default: undefined },
    authId: { type: String, required: true },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const loading = ref(false);

    const shouldRender = computed((): boolean => props.integration !== undefined);

    const title = computed((): string => t('pay-with-authorize-dot-net'));

    const externalUrl = computed((): string => {
      if (props.integration.externalUrl === undefined) {
        return '';
      }
      if (!props.integration.externalUrl) {
        return `/auth/authorizenet/${props.document.id}/${props.recipient.id}/${props.authId}`;
      }
      return props.integration.externalUrl;
    });

    const handleClose = () => {
      emit('close');
    };

    return {
      ButtonType,
      ModalSize,
      loading,
      shouldRender,
      title,
      externalUrl,
      handleClose,
    };
  },
});
</script>

<style lang="scss" scoped>
.authorizenet-iframe {
  width: 95%;
  height: 500px;
}
</style>
